import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI, handleAuthSuccess } from '../services/api';

const GoogleLoginButton = ({ 
  onSuccess, 
  onError, 
  disabled = false,
  theme = "outline",
  size = "large",
  text = "Sign in with Google",
  width = "100%",
  className = ""
}) => {
  const navigate = useNavigate();
  const buttonRef = useRef(null);
  const isInitialized = useRef(false);

  useEffect(() => {
    const initializeGoogleSignIn = () => {
      if (window.google && window.google.accounts && !isInitialized.current) {
        window.google.accounts.id.initialize({
          client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID || "660900809164-mbeec6uphbbo0s2pk2kkf5copk2a7aj3.apps.googleusercontent.com",
          callback: handleCredentialResponse,
          auto_select: false,
          cancel_on_tap_outside: true,
        });

        // Render the button
        if (buttonRef.current) {
          window.google.accounts.id.renderButton(buttonRef.current, {
            theme: theme,
            size: size,
            text: text,
            width: width,
            logo_alignment: "left",
          });
        }

        isInitialized.current = true;
      }
    };

    const handleCredentialResponse = async (response) => {
      console.log("Google login response received:", response);

      try {
        // Use the existing authAPI.googleAuth function
        const result = await authAPI.googleAuth(response.credential);
        
        console.log("Backend response:", result);

        // Call success callback if provided
        if (onSuccess) {
          onSuccess(result);
        }

        // Use the existing handleAuthSuccess helper
        handleAuthSuccess(result, navigate);

      } catch (error) {
        console.error("Google authentication error:", error);
        
        // Call error callback if provided
        if (onError) {
          onError(error);
        }
      }
    };

    // Check if Google script is already loaded
    if (window.google) {
      initializeGoogleSignIn();
    } else {
      // Load the Google script if not already loaded
      const existingScript = document.querySelector('script[src="https://accounts.google.com/gsi/client"]');
      
      if (!existingScript) {
        const script = document.createElement("script");
        script.src = "https://accounts.google.com/gsi/client";
        script.async = true;
        script.defer = true;
        script.onload = initializeGoogleSignIn;
        document.head.appendChild(script);
      } else {
        // Script exists, wait for it to load
        existingScript.addEventListener('load', initializeGoogleSignIn);
      }
    }

    // Cleanup function
    return () => {
      isInitialized.current = false;
    };
  }, [theme, size, text, width, onSuccess, onError, navigate]);

  return (
    <div className={className}>
      <div
        ref={buttonRef}
        style={{
          opacity: disabled ? 0.5 : 1,
          pointerEvents: disabled ? 'none' : 'auto'
        }}
      />
      {disabled && (
        <div className="text-center text-sm text-gray-500 mt-2">
          Google Sign-In temporarily unavailable
        </div>
      )}
    </div>
  );
};

export default GoogleLoginButton; 